module.exports = __webpack_public_path__ + "img/coyote.6fdcc78b.svg";